import type * as React from 'react';
import { type FC, useEffect, useRef } from 'react';

import { useIntersectionObserver } from '@crehana/react-hooks';

import { useScrollContext } from './ScrollContext';

export interface UpdateScrollProps {
  sectionId: string;
  onTrack?: () => void;
}

const UpdateScroll: FC<React.PropsWithChildren<UpdateScrollProps>> = ({
  onTrack,
  sectionId,
}) => {
  const ref = useRef(null);
  const observer = useIntersectionObserver(ref, { freezeOnceVisible: false });
  const { handleSetSectionVisible } = useScrollContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy code - correctness/useExhaustiveDependencies
  useEffect(() => {
    if (observer?.isIntersecting) {
      handleSetSectionVisible(sectionId);
    }

    if (onTrack) {
      onTrack();
    }
  }, [observer?.isIntersecting]);

  return <div ref={ref} />;
};

export default UpdateScroll;
